module.exports = __webpack_public_path__ + "static/media/trash.37594dae.svg";